"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileGetResponseSchema = exports.ProfileGetResultSchema = exports.ProfileGetSchema = void 0;
/* eslint-disable perfectionist/sort-objects */
const zod_1 = require("zod");
const schemas_1 = require("../../../schemas");
const ProfilePersonalDetailSchema = schemas_1.CandidateSchema.pick({
    dateOfBirth: true,
    email: true,
    firstName: true,
    gender: true,
    lastName: true,
    phoneNumber: true,
    selfIntroduction: true,
});
const ProfileEducationSchema = schemas_1.CandidateEducationSchema.pick({
    fieldOfStudy: true,
    institution: true,
    level: true,
    status: true,
    endDate: true,
    startDate: true,
});
const CertificationSchema = schemas_1.LanguageSkillCertificationSchema.pick({
    certificationId: true,
    score: true,
}).extend({ name: zod_1.z.string() });
const ProfileLanguageSkillSchema = schemas_1.CandidateLanguageSkillSchema.pick({
    languageId: true,
    communication: true,
    reading: true,
    writing: true,
}).extend({
    certifications: CertificationSchema.array(),
    language: schemas_1.LocalizedFieldSchema,
    languageCode: zod_1.z.string(),
});
const ExperienceEntrySchema = zod_1.z.object({
    entity: schemas_1.LeafWithChainNodeSchema,
    yearOfExperience: zod_1.z.number(),
});
const ProfileExperienceSchema = zod_1.z.object({
    hasManagementExperience: zod_1.z.boolean().default(false),
    occupations: ExperienceEntrySchema.array(),
    industries: ExperienceEntrySchema.array(),
});
const ProfileSkillSchema = schemas_1.CandidateSkillSchema.pick({
    id: true,
    name: true,
    type: true,
    yearOfExperience: true,
});
const ProfileWorkHistoriesSchema = zod_1.z.object({
    employmentSummary: schemas_1.CandidateSchema.pick({
        employmentStatus: true,
        jobChangeCount: true,
        hideCompanyName: true,
    }),
    histories: schemas_1.CandidateWorkHistorySchema.pick({
        id: true,
        annualSalary: true,
        companyName: true,
        employmentType: true,
        jobDetail: true,
        endDate: true,
        startDate: true,
    }).extend({
        industry: schemas_1.LeafWithChainNodeSchema.nullable(),
        occupation: schemas_1.LeafWithChainNodeSchema.nullable(),
    }).array(),
});
const ProfileJobPreferences = schemas_1.CandidateJobPreferenceSchema.pick({
    desiredAnnualSalary: true,
    isOpenToAnyIndustry: true,
    isOpenToAnyLocation: true,
    jobSearchStatus: true,
    relocationPreference: true,
}).extend({
    industries: schemas_1.LeafWithChainNodeSchema.array(),
    locations: zod_1.z.object({
        provinceId: zod_1.z.string(),
        name: schemas_1.LocalizedFieldSchema,
    }).array(),
    occupations: schemas_1.LeafWithChainNodeSchema.array(),
});
exports.ProfileGetSchema = zod_1.z.object({
    address: schemas_1.LocationBaseSchema.nullable(),
    personal: ProfilePersonalDetailSchema,
    educations: ProfileEducationSchema.array(),
    languageSkills: ProfileLanguageSkillSchema.array(),
    qualifications: zod_1.z.object({ name: zod_1.z.string() }).array(),
    preferences: schemas_1.LeafWithChainNodeSchema.array(),
    skills: ProfileSkillSchema.array(),
    experiences: ProfileExperienceSchema,
    workHistories: ProfileWorkHistoriesSchema,
    jobPreferences: ProfileJobPreferences,
});
exports.ProfileGetResultSchema = zod_1.z.object({ profile: exports.ProfileGetSchema });
exports.ProfileGetResponseSchema = (0, schemas_1.createSuccessResponseSchema)(exports.ProfileGetResultSchema);
